import { Component, Input, OnChanges } from '@angular/core';
import { Group } from 'core/models/group';
import { GroupsService } from 'core/services/groups.service';
import { Course } from 'core/models';

@Component({
  selector: 'lms-group-activity',
  templateUrl: './group-activity.component.html',
  styleUrls: ['./group-activity.component.scss']
})
export class GroupActivityComponent implements OnChanges {
  @Input() group: Group;
  @Input() course: Course;
  public groupActivityListId = 'GROUP_ACTIVITY_LIST';
  public filters: Map<string, string>;

  constructor(public groupsService: GroupsService) {}

  public ngOnChanges(): void {
    this.filters = new Map<string, string>().set('groupId', this.group.id);
  }
}
